// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {map} from 'lodash';

// Components
import OverlayContainer from './overlay-container';

// Styles
import './overlay-portal.scss';

class OverlayPortal extends Component {
    renderOverlay(config, id) {
        return <OverlayContainer {...config} key={id} />;
    }

    render() {
        const {overlays} = this.props;

        return <div className="overlay-portal">{map(overlays, this.renderOverlay)}</div>;
    }
}

OverlayPortal.propTypes = {
    overlays: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    overlays: state.overlays,
});

export default connect(mapStateToProps)(OverlayPortal);
